// extracted by mini-css-extract-plugin
export default {"root":"MarketsCards_root__PYtSu","card":"MarketsCards_card__d8uYs"};